// extracted by mini-css-extract-plugin
export default {"video":"youtube-modal_video__LfBTL","close":"youtube-modal_close__-xPBC","show":"youtube-modal_show__mu2xu"};